module.exports = __webpack_public_path__ + "img/instr_3.f1213820.svg";